// The branded hostname in front of the Auth0 tenant. It is a second front door onto the same
// tenant (dev-jhv7ui5so1a03x1j.us.auth0.com), so the users, roles, clients and login page are
// identical either way; only the issuer on the token changes, and the API accepts both
// (Auth0:CustomDomain in the API's appsettings.json).
//
// One tenant serves development, stage and production, so this value is the same everywhere.
// Moving here costs every signed-in person one fresh sign-in, because the Auth0 session cookie
// belongs to whichever hostname they authenticated at and does not follow across.
const domain = 'login.innovarxi.com';
const clientId = 'ufwdtkOLlZGMsFaBFBIWJn86rfjrOcIX';

export default {
  domain,
  clientId,
};
